<template>
  <!-- モーダルウィンドウ -->
  <div
    class="c-modal c-modal--error"
    :class="{'is-active': isActive}"
  >
    <div class="c-modal__bg" @click="onCloseClick"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="onCloseClick">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-modal__data" v-html="message"></div>
      </div>
    </div>
  </div>
<!-- /モーダルウィンドウ -->
</template>

<script>
export default {
  props: {
    isActive: { type: Boolean, required: true },
    message: { type: String, required: true },
    onCloseClick: { type: Function, required: true },
  },
};
</script>
